import { isInValidArray } from '~/utils/validation'

const convertFoodOptions = (foodOptions = []) => {
  if (isInValidArray(foodOptions)) return []

  return foodOptions.map((foodOption) => {
    return {
      ...foodOption,
    }
  })
}

const convertFoodOptionTypes = (foodOptionTypes = []) => {
  if (isInValidArray(foodOptionTypes)) return []

  return foodOptionTypes.map((foodOptionType) => {
    const { food_options } = foodOptionType

    return {
      ...foodOptionType,
      foodOptions: convertFoodOptions(food_options),
    }
  })
}

/* Tính tổng tiền chi tiết topping */
const totalMoneyDetailTopping = (food_options) => {
  if (!Array.isArray(food_options)) return 0

  return food_options.reduce((total, current_topping) => {
    const { price, quantity } = current_topping
    return total + (quantity || 1) * (price || 0)
  }, 0)
}

/* Tính tổng tiền topping type */
const totalMoneyTopping = (food_option_types) => {
  if (!Array.isArray(food_option_types)) return 0
  return food_option_types.reduce((total, current_topping) => {
    const { food_options } = current_topping
    return total + totalMoneyDetailTopping(food_options)
  }, 0)
}

/** Tính giá món ăn  : (giá gốc + tổng tiền topping )*/
const totalPriceFood = (item) => {
  const { price, food_option_types } = item
  return price + totalMoneyTopping(food_option_types)
}

export { convertFoodOptions, convertFoodOptionTypes, totalPriceFood }
